
document.addEventListener('DOMContentLoaded', function() {

  //console.log('Salts Extra JS loaded');

  const params = new URLSearchParams(window.location.search);
  const initialVariant = params.get('variant');
  
  if (initialVariant) {
    console.log('Initial vairant: ' + initialVariant);
    filterProductSlides(initialVariant);
  }

  // event triggred by shopify code
    document.addEventListener('variant:update', function(event) {
        console.log('Variant changes...');
        var variant = event.detail.resource; // Get the newly selected variant
        //update the SKU on the product page
        if ( variant ) {
          console.log(variant.id);
          updateSku(variant.sku);
          filterProductSlides(variant.id);
        }
        
  });


    /*
    const originalDispatch = Element.prototype.dispatchEvent;
    Element.prototype.dispatchEvent = function(event) {
        if (event.type.includes('variant') || event.type.includes('change')) {
            console.log('Event Triggered:', event.type, event);
        }
        return originalDispatch.apply(this, arguments);
    };
    */



});

function updateSku(sku) {
  var skuParagraph = document.getElementById('VariantSku');
  if (skuParagraph) {
    skuParagraph.textContent = sku;
  }

}

/**
 * Filters product slides based on a product ID.
 * @param {string|number} variantId - The ID to match against data-product-id.
 */
function filterProductSlides(variantId) {
  // Select all divs that have a data-product-id attribute
  const slides = document.querySelectorAll('slideshow-slide[data-variant-id]');
  const slideControls = document.querySelectorAll('.slideshow-control[data-variant-id]');

  console.log(slides);

  slides.forEach(slide => {
    // slide.dataset.variantId matches data-variant-id - clever dataset!
    if (slide.dataset.variantId === String(variantId) || slide.dataset.variantId === 'xall') {
      slide.style.display = 'block'; // Or 'flex', 'inline-block', etc.
      slide.style.visibility = 'visible';
    } else {
      slide.style.display = 'none';
      slide.style.visibility = 'hidden';
    }
  });

  slideControls.forEach(control => {
    // control.dataset.variantId matches data-variant-id - clever dataset!
    if (control.dataset.variantId === String(variantId) || control.dataset.variantId === 'xall') {
      control.style.display = 'block'; // Or 'flex', 'inline-block', etc.
      control.style.visibility = 'visible';
    } else {
      control.style.display = 'none';
      control.style.visibility = 'hidden';
    }
  });

}
